<template>
  <!-- <div class="search-bar"> -->
    <el-autocomplete
      class="search-bar"
      style="width: 100%"
      v-model="search_string"
      :fetch-suggestions="querySearch"
      placeholder="Search or command…"
      @select="handleSelect"
      :clearable="true"
      ref="input">

    <font-awesome-icon
      style="cursor: pointer; margin: 0 0.2em"
      class="el-input__icon"
      slot="prefix"
      :icon="'search' /* ($refs.input && $refs.input.activated) ? 'search' : 'times' */"
      @click="handleIconClick" />

    <template slot-scope="{ item }">
      <div
        :class="{ 'search-result': true, 'is-command': item.type === 'command' }"
        v-html="item.matched_text"></div>
      <!--
      <template v-if="item.type === 'goal'">
        <div class="search-result">{{ item.name }}</div>
      </template>
      <template v-else-if="item.type === 'command'">
        <div class="search-result">{{ item.name }}</div>
      </template>
      -->
    </template>

  </el-autocomplete>
</template>

<script>
import Fuse from 'fuse-js-latest'

const SEARCH_OPTIONS = {
  shouldSort: true,
  tokenize: true,
  threshold: 0,
  location: 0,
  distance: 100,
  includeMatches: true,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    "name",
    "cachedName",
  ]
};

const COMMANDS = [{
  name: 'Divide by zero',
  type: 'command',
  id: 'DIVIDE_BY_ZERO'
}, {
  name: 'Start new session',
  type: 'command',
  id: 'START_SESSION'
}, {
  name: 'Create new goal',
  type: 'command',
  id: ''
}, {
  name: 'Invite colleagues',
  type: 'command',
  id: ''
}, {
  name: 'Invite friends',
  type: 'command',
  id: ''
}, {
  name: 'Invite family members',
  type: 'command',
  id: 'CREATE_GOAL'
}, {
  name: 'Share Visionboard',
  type: 'command',
  id: ''
}, {
  name: 'Share Goal',
  type: 'command',
  id: ''
}, {
  name: 'Share Challenge',
  type: 'command',
  id: ''
}, {
  name: 'Why does Goalpilot work so well?',
  type: 'command',
  id: ''
}, {
  name: 'How can I invite other people to Goalpilot?',
  type: 'command',
  id: ''
}, {
  name: 'Motivation',
  type: 'command',
  id: 'MOTIVATION'
}, {
  name: 'How am I doing today?',
  type: 'command',
  id: 'DAILY_STATS'
}];

export default {
  data: () => ({
    search_string: '',
    cache_created: false,
    search_cache: [],
    quoteNr: 0
  }),
  computed: {
    // ...mapGetters("goal", [
    //   "goal_list_meta_ready_without_deleted",
    // ]),
  },
  created() {
    this.fuse = new Fuse([], SEARCH_OPTIONS);

    this.keyboardShortcutListener = (e) => {
      if ( ( e.ctrlKey && e.keyCode === 80 ) || ( e.altKey && e.keyCode === 80 ) ) {
        console.log("SHORTCUT", this.$refs.input);
        this.$refs.input.focus();
      }
      if ( e.key === 'Escape' || e.code === 'Escape' ) {
        // console.log(this.$refs.input);
        this.search_string = '';
        // this.$refs.input.close(); --> DOES NOT WORK
        this.$refs.input.suggestions = [];
        this.$refs.input.$children[0].blur();
      }
    }
    window.addEventListener('keyup', this.keyboardShortcutListener);
  },
  beforeDestroy() {
    if ( this.keyboardShortcutListener ) {
      window.removeEventListener('keyup', this.keyboardShortcutListener)
    }
  },
  methods: {
    createCache() {
      console.log("[search] creating cache...");
      let goal_list = this.$models.goalMeta.getters.all_goals_loaded.map(goal => {
        return { name: goal.cachedName, id: goal.id, type: 'goal' }
      });

      // TODO: Tasks, efforts, etc.

      let effortCommands = goal_list.map(goal => {
        return {
          name: 'Create new tasklist for <' + goal.name + '>',
          type: 'command',
          id: 'CREATE_COMMITMENT',
          goalId: goal.id
        }
      })

      this.search_cache = [
        ...goal_list,
        ...COMMANDS,
        ...effortCommands
      ];

      this.fuse = new Fuse(this.search_cache, SEARCH_OPTIONS);
      this.cache_created = true;

      console.log("[search] search_cache", this.search_cache);

      /* Automatically invalidate cache after 15s */
      setTimeout(() => { this.cache_created = false }, 15 * 1e3)
    },

    formatMatches( text, matches ) {
      /* Build a formatted string */
      let result = [];
      var pair = matches.shift()
      for ( var i = 0; i < text.length; i++ ) {
        var char = text.charAt(i)
        if ( pair && i === pair[0] ) {
          result.push('<strong>')
        }
        if ( char === '<' ) {
          result.push('<span class="no-style">')
        } else if ( char === '>' ) {
          result.push('</span>')
        } else {
          result.push(char)
        }
        if ( pair && i === pair[1] ) {
          result.push('</strong>')
          pair = matches.shift()
        }
      }
      return result.join('');
    },

    querySearch(queryString, cb) {

      if ( !this.cache_created ) {
        this.createCache();
      }

      var results = this.fuse.search(queryString);
      results = results.map(result => {
        let matches = result.matches.map(match => match.indices);
        matches = [].concat.apply([], matches);

        return {
          ...result.item,
          matched_text: this.formatMatches( result.item.name, matches )
        };
      });

      if ( queryString ) {

        this.quoteNr = (this.quoteNr + 1) % 3
        // Motivation feature
        let randomQuote = this.randomMotivationalQuote(this.quoteNr);
        let randomGif  = this.randomMotivationalGif(this.quoteNr);
        console.log('randomQuote',randomQuote)
        console.log('randomGif',randomGif)

        results.push({
            name: queryString,
            matched_text: '',
            type: 'command',
            id: 'MOTIVATION'
        })

        results.push({
            name: queryString,
            matched_text: '<div  style="display: block; overflow: hidden;text-overflow: ellipsis; margin-right: 5px;" ><table><tr><td >&quot;' + randomQuote.quote + '&quot; - ' +  randomQuote.author + '</td></tr><tr><td><img src="' + randomGif + '" width="30%"></td></tr></table></div>',
            type: 'command',
            id: 'MOTIVATION'
        })
        results.push({
            name: queryString,
            matched_text: '--- Goalpilot shortcuts ---',
            type: 'text',
        })
        results.push({
            name: queryString,
            matched_text: 'Create new task <span class="no-style">' + queryString + '</span>',
            type: 'command',
            id: 'CREATE_TASK',
        })
        results.push({
            name: queryString,
            matched_text: 'Create new tasklist <span class="no-style">' + queryString + '</span>',
            type: 'command',
            id: 'CREATE_COMMITMENT',
        })
        results.push({
            name: queryString,
            matched_text: 'Create new goal <span class="no-style">' + queryString + '</span>',
            type: 'command',
            id: 'CREATE_GOAL',
        })

      }

      console.log("[search] results", results);
      cb(results);
    },

    handleSelect(item) {
      console.log("[search] handle select", item.type, item.id);
      switch ( item.type ) {
        case 'goal':
          this.$router.push({ name: 'goal', params: { goalId: item.id } });
          break;

        case 'command':
          this.handleCommand( item.id, item )
          break;
      }
    },

    handleCommand( command, payload ) {
      switch ( command ) {
        case 'DIVIDE_BY_ZERO':
          document.body.style.backgroundColor = 'black';
          for ( var element of document.body.children ) {
            if ( element.style ) {
              element.style.transition = 'all 15s';
              element.style.opacity = 0;
            }
          }
        break;

        case 'START_SESSION':
          this.$router.push({ name: 'session', params: {} });
          break;

        case 'CREATE_GOAL':
          this.$root.showNewModal('goal', { isTeamgoal: false });
          break;

        case 'CREATE_COMMITMENT':
          console.log("payload.goalId", payload.goalId);
          this.$root.showNewModal('effort', { goalId: payload.goalId });
          break;

        case 'CREATE_TASK':
          console.log("CREATE_TASK payload.name", payload.name);
          console.log("TODO");
          break;

        // ...
      }
    },

    handleIconClick(ev) {
      this.$alert(
        '<kbd>Ctrl + P</kbd> (Mac) or<br /><kbd>Alt + P</kbd> (Windows)',
        'Shortcut for search', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'OK',
        type: 'info',
        center: true
      })
    },

    randomMotivationalQuote(seed) {
      let quotes = [
        ["If you really look closely, most overnight successes took a long time.", 'Steve Jobs'],
        ["The successful warrior is the average man, with laser-like focus.", 'Bruce Lee'],
        ["In the middle of difficulty lies opportunity.", 'Albert Einstein'],
        ["A person who never made a mistake never tried anything new.", 'Albert Einstein']
      ]
      //let randomNr = Math.floor(Math.random() * quotes.length);
      return { quote: quotes[seed][0], author: quotes[seed][1] };
    },
    randomMotivationalGif(seed) {
      let images = [
        'https://media.giphy.com/media/yoJC2K6rCzwNY2EngA/giphy.gif',
        'https://media.giphy.com/media/iXDe1s3spQUZG/giphy.gif',
        'https://media.giphy.com/media/xT4uQBNEr2CFjaV84M/giphy.gif'
      ]
      //let randomNr = Math.floor(Math.random() * images.length);
      return images[seed];
    }
  }
}
</script>

<style>
.search-bar .el-input__inner {
  height: 36px;
  line-height: 36px;
}
.search-result.is-command {
  color: #174777;
  font-family: monospace;
  font-weight: bold;
}
.search-result .no-style {
  font-family: var(--font-family-sans-serif);
  font-weight: normal;
}
.search-result strong {
  background-color: yellow;
}
</style>
